import Translator from '../translator'
import React, {useEffect} from 'react'
import { EditParticipantsDialogAll } from './edit-participants/editParticipantsDialogAll'
import { ParticipantsViewModel } from './edit-participants/participantsViewModel'
import Settings from '../settings'
import { RootStore } from '../../datastores/rootStore'

export function CartContentTitle(props) {
  const [isOpen, setIsOpen] = React.useState(false)
  let cart = RootStore.getInstance().cart
  const [p] = React.useState(new ParticipantsViewModel([]))
    useEffect(() => {
        p.reset()
    }, [])
  return (
    <div className='mtt-cart-content__title'>
      <h1 className='mtt-cart-title'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='21.42'
          height='24'
          viewBox='0 0 17.846 20'
        >
          <path
            d='M24.471,37h10.9a3.475,3.475,0,0,0,3.471-3.471V23.154a.617.617,0,0,0-.615-.615H34.538v-.923a4.615,4.615,0,1,0-9.231,0v.923H21.615a.617.617,0,0,0-.615.615V33.529A3.475,3.475,0,0,0,24.471,37Zm2.068-15.385a3.385,3.385,0,0,1,6.769,0v.923H26.538Zm-4.308,2.154h3.077v1.538a.615.615,0,1,0,1.231,0V23.769h6.769v1.538a.615.615,0,1,0,1.231,0V23.769h3.077v9.76a2.244,2.244,0,0,1-2.24,2.24h-10.9a2.244,2.244,0,0,1-2.24-2.24Z'
            transform='translate(-21 -17)'
            fill='currentColor'
          />
        </svg>
        {Translator.translate('Kurv', 'cart')}
      </h1>
      <button
        className='button lightgrey small'
        onClick={() => {
          setIsOpen(true)
        }}
      >
        <img
          src={Settings.getSetting('icons/participants.svg', 'cart')}
          alt=''
          width={'19.98'}
          height={'13.98'}
        />
        {Translator.translate(
          'Tilføj samme deltagere til alle arrangementer',
          'cart'
        )}
      </button>
      <EditParticipantsDialogAll
        eventGroups={cart.eventGroups}
        open={isOpen}
        onClose={() => {
          p.reset()
          setIsOpen(false)
        }}
        p={p}
      />
    </div>
  )
}
